import Flickity from 'flickity';
require('flickity-imagesloaded');

export default function cardsCarousel() {
  document.querySelectorAll('[data-cards-carousel]').forEach((element) => {
    const container = element.querySelector('.cards--cards');
    if (!container) return;

    new Flickity(container, {
      prevNextButtons: true,
      pageDots: false,
      contain: true,
      groupCells: 1,
      cellAlign: 'left',
      imagesLoaded: true,
    });
  });
}
